import axios from 'axios';

// 维修工种设置
export function repairPositionSet(data) {
  return axios({
    url: '/fy/setting/repairPositionSet',
    method: 'POST',
    data: data,
  });
}

// 维修工种更新
export function repairPositionUpdate(data) {
  return axios({
    url: '/fy/setting/repairPositionUpdate',
    method: 'POST',
    data: data,
  });
}

// 删除维修工种
export function repairPositionDelete(data) {
  return axios({
    url: '/fy/setting/repairPositionDelete',
    method: 'POST',
    data: data,
  });
}

// 维修人员设置
export function repairPersonSet(data) {
  return axios({
    url: '/fy/setting/repairPersonSet',
    method: 'POST',
    data: data,
  });
}

// 维修人员更新
export function repairPersonUpdate(data) {
  return axios({
    url: '/fy/setting/repairPersonUpdate',
    method: 'POST',
    data: data,
  });
}

// 维修人员删除
export function repairPersonDelete(data) {
  return axios({
    url: '/fy/setting/repairPersonDelete',
    method: 'POST',
    data: data,
  });
}

// 获取维修岗位列表不分页(fy:setting:getRepairPositionList)
export function getRepairPositionListNoPage(params) {
  return axios({
    url: '/fy/setting/getRepairPositionListNoPage',
    method: 'GET',
    params: params,
  });
}

// 根据姓名查询教师(fy:setting:auditTeacherSet)
export function getTeacherList(params) {
  return axios({
    url: '/fy/setting/getTeacherList',
    method: 'GET',
    params: params,
  });
}
